module.exports = __webpack_public_path__ + "Flag-212.46899fa6442622f11ce9b819f7a286ea.svg";